import { useTranslation } from 'react-i18next';
import { showColumns } from '../useColumns';
import { useDeleteById } from 'RestAPIs/useDeleteById';
import { showErrorSnackbar } from 'components/shared/Snackbar';
import { useState } from 'react';
import ConnectionDetailDrawer from '../ConnectionDetailDrawer';
import { IMPORT_EMPLOYEE_CONFIG } from 'RestAPIs/endpoints';
import { ImportEmployeeSetting } from '../types';
import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';

type ConnectionGridProps = {
  connectionTable: ImportEmployeeSetting[];
  isFetching: boolean;
};
export const ConnectionGrid = ({
  connectionTable,
  isFetching
}: ConnectionGridProps) => {
  const { t } = useTranslation('common');
  const [openDetails, setOpenDetails] = useState<boolean>(false);
  const [rowData, setRowData] = useState();

  const connectionColumns = showColumns(t);

  const { mutateAsync: deleteRow } = useDeleteById(IMPORT_EMPLOYEE_CONFIG, [
    'importEmployeeConfig'
  ]);

  const handleDeleteRow = async (id) => {
    try {
      await deleteRow(id);
    } catch {
      showErrorSnackbar();
    }
  };

  return (
    <>
      <TableCRUDLayout
        sx={{ marginTop: 2 }}
        onAddClick={() => {
          setOpenDetails(true);
          setRowData(undefined);
        }}
        shouldRenderToolBar={false}
        renderFormContainer={false}
        editable={false}
        onEditClick={(_, row) => {
          setOpenDetails(true);
          setRowData(row);
        }}
        columns={connectionColumns}
        rows={connectionTable}
        loading={isFetching}
        onDeleteClick={(ids) => handleDeleteRow(ids)}
        getRowId={(item) => item.impEmployeeConfigId}
        confirmationTitle={t('deleteDialog.title')}
        confirmationBody={t('deleteDialog.body')}
        addRowDialog={
          <ConnectionDetailDrawer
            tableRow={rowData}
            containerOpen={openDetails}
            handleClose={() => {
              setOpenDetails(false);
            }}
          />
        }
      />
    </>
  );
};
